import React, { useContext, useEffect, useState } from "react";
import InputForm from "../../Components/InputForm/InputForm";
import DateForm from "../../Components/DateForm/DateForm";
import { LoaderContext, getContext } from "../../Helpers/Context/Context";
import { APICall } from "../../Helpers/Network/APICalls";
import notify, { ToastType } from "../../Helpers/ToastNotification";
import { SettlementDetailsById } from "../../Helpers/APIEndPoints/EndPoints";
import { GenericMasterType, LoanTypeEnum } from "../../Helpers/Enums/Enum";

const StlmtLoanDetails = (props) => {
  // const { selectNextTab, selectPreviousTab } = props;
  const { showLoader, hideLoader } = useContext(LoaderContext);

  const [AdditionalLoanAmount, setAdditionalLoanAmount] = useState<any>();
  const [AdditionalAmountByIntTeam, setAdditionalAmountByIntTeam] =
    useState<any>();
  const [LoanAmount, setLoanAmount] = useState();
  const [LoanType, setLoanType] = useState<any>();
  const [OutstandingAmount, setOutstandingAmount] = useState<any>();
  const [ApplicationDate, setApplicationDate] = useState<any>();
  const [ApplicationNo, setApplicationNo] = useState<any>();

  const [OutstandingAmountAL, setOutstandingAmountAL] = useState<any>();
  const [isShortTerm, setIsShortTerm] = useState<any>(false);

  const [ApplicationNoShort, setApplicationNoShort] = useState<any>();
  const [LoanTypeShort, setLoanTypeShort] = useState<any>();
  const [LoanAmountShort, setLoanAmountShort] = useState<any>();
  const [OutstandingAmountShort, setOutstandingAmountShort] = useState<any>();
  const [ApplicationDateShort, setApplicationDateShort] = useState<any>();

  const [DocumentNoShort, setDocumentNoShort] = useState<any>();
  const [DocumentNo, setDocumentNo] = useState<any>();
  const [DocumentNoAL, setDocumentNoAL] = useState<any>();

  
  const StateCurrentStatus = props.statecurrentstatus;
  const StateSetId = props.statesetid;
  const StateMemberId = props.statememberid;
  const StateMode = props?.mode;

  useEffect(() => {
    getSettlementDetails();
  }, []);

  const getSettlementDetails = async () => {
    showLoader();
    let requestParams = {
      SetId: StateSetId,
      MemberId: StateMemberId,
    };
    const res = await APICall(SettlementDetailsById, requestParams);

    if (res.Message === "Ok" && res.Data !== null) {
    
      let i = 0;
      
      if (res.Data?.[i]?.Lrd_LoanType == LoanTypeEnum.SHORTTERM) {
        setIsShortTerm(true);
        setApplicationNoShort(res?.Data?.[i]?.ApplicationNo);
        setLoanTypeShort(res?.Data?.[i]?.Lrd_LoanType);
        setLoanAmountShort(res?.Data?.[i]?.Lrd_LoanAmount);
        setOutstandingAmountShort(res?.Data?.[i]?.Lrd_OutstandingAmount);
        setApplicationDateShort(res?.Data?.[i]?.ApplicationDate);
        setDocumentNoShort(res?.Data?.[i]?.Lrd_DocumentNo);
        i = 1;
      }
      if (res.Data?.[i]?.Lrd_LoanType == LoanTypeEnum.LONGTERM) {
        setLoanAmount(res?.Data?.[i]?.Lrd_LoanAmount);
        setDocumentNo(res?.Data?.[i]?.Lrd_DocumentNo);
        setLoanType(res?.Data?.[i]?.Lrd_LoanType);
        setAdditionalLoanAmount(res?.Data?.[i]?.Lrd_AdditionalLoanAmount);
        setAdditionalAmountByIntTeam(
          res?.Data?.[i]?.Lrd_AdditionalAmountByIntTeam
        );
        setApplicationDate(res?.Data?.[i]?.ApplicationDate);
        setApplicationNo(res?.Data?.[i]?.ApplicationNo);
        setOutstandingAmount(res?.Data?.[i]?.Lrd_OutstandingAmount);
        setOutstandingAmountAL(res?.Data?.[i]?.Lrd_OutstandingAmountAL);
      }
      hideLoader();
    } else {
      notify(1, "Data not found");
      hideLoader();
    }
  };
  return (
    <>
      <div className="row ">
        {isShortTerm && (
          <>
            <div className="col-lg-12">
              <h4>Short term</h4>
            </div>
            <div className="col-lg-4 col-md-4 col-sm-6">
              <div className="form-group"></div>
              <label>Loan Application Number</label>
              <InputForm
                placeholder={"Application Number"}
                value={ApplicationNoShort}
                isDisabled={true}
                maxLength={30}
              />
            </div>
            <div className="col-lg-4 col-md-4 col-sm-6">
              <div className="form-group"></div>
              <label>Document Number</label>
              <InputForm
                placeholder={"Document Number"}
                value={
                  DocumentNoShort == 0
                    ? "Document Number Not Generated"
                    : DocumentNoShort
                }
                isDisabled={true}
                maxLength={30}
              />
            </div>
            <div className="col-lg-4 col-md-4 col-sm-6">
              <div className="form-group"></div>
              <label>Loan Application Date</label>
              <DateForm
                // disableFuture={true}
                value={ApplicationDateShort}
                onChange={(event: any) => console.log()}
                placeholder="DD-MM-YYYY"
                isDisabled={true}
              />
            </div>
            <div className="col-lg-4 col-md-4 col-sm-6">
              <div className="form-group"></div>
              <label>Loan Amount</label>
              <InputForm
                placeholder={"Loan Amount"}
                value={LoanAmountShort}
                isDisabled={true}
              />
            </div>
            <div className="col-lg-4 col-md-4 col-sm-6">
              <div className="form-group"></div>
              <label>Balance Loan Amount</label>
              <InputForm
                placeholder={"Outstanding Amount"}
                value={OutstandingAmountShort}
                isDisabled={true}
              />
            </div>
          </>
        )}
        {!isShortTerm && (
          <>
            <div className="col-lg-12  mt-2">
              <h4>Long term</h4>
            </div>

            <div className="col-lg-4 col-md-4 col-sm-6">
              <div className="form-group"></div>
              <label>Loan Application Number</label>
              <InputForm
                placeholder={"Application Number"}
                value={ApplicationNo}
                // onChange={(val: any) => {
                //   let value = val.target.value;
                //   onChange("lastName", value);
                // }}
                isDisabled={true}
                maxLength={30}
              />
            </div>
            <div className="col-lg-4 col-md-4 col-sm-6">
              <div className="form-group"></div>
              <label>Document Number</label>
              <InputForm
                placeholder={"Document Number"}
                value={
                  DocumentNo == 0 ? "Document Number Not Generated" : DocumentNo
                }
                // onChange={(val: any) => {
                //   let value = val.target.value;
                //   onChange("lastName", value);
                // }}
                isDisabled={true}
                maxLength={30}
              />
            </div>
            <div className="col-lg-4 col-md-4 col-sm-6">
              <div className="form-group"></div>
              <label>Loan Application Date</label>
              <DateForm
                // disableFuture={true}
                value={ApplicationDate}
                onChange={(event: any) => console.log()}
                placeholder="DD-MM-YYYY"
                isDisabled={true}
              />
            </div>
            <div className="col-lg-4 col-md-4 col-sm-6">
              <div className="form-group"></div>
              <label>Loan Amount</label>
              <InputForm
                placeholder={"Loan Amount"}
                value={LoanAmount}
                // onChange={(event: any) =>
                //   handleTextEvent(event, "accountNumber")
                // }
                isDisabled={true}
              />
            </div>
            <div className="col-lg-4 col-md-4 col-sm-6">
              <div className="form-group"></div>
              <label>Balance Loan Amount</label>
              <InputForm
                placeholder={"Outstanding Amount"}
                value={OutstandingAmount}
                // onChange={(event: any) =>
                //   handleTextEvent(event, "accountNumber")
                // }
                isDisabled={true}
              />
            </div>
          </>
        )}
      </div>
      {LoanType == LoanTypeEnum.LONGTERM && (
        <div className="row mt-5">
          <div className="col-lg-12">
            <h4>Additional Long term</h4>
          </div>

          <div className="col-lg-4 col-md-4 col-sm-6">
            <div className="form-group"></div>
            <label>Loan Application Number</label>
            <InputForm
              placeholder={"Application Number"}
              value={ApplicationNo}
              // onChange={(val: any) => {
              //   let value = val.target.value;
              //   onChange("lastName", value);
              // }}
              isDisabled={true}
              maxLength={30}
            />
          </div>

          <div className="col-lg-4 col-md-4 col-sm-6">
            <div className="form-group"></div>
            <label>Loan Application Date</label>
            <DateForm
              // disableFuture={true}
              value={ApplicationDate}
              onChange={(event: any) => console.log()}
              placeholder="DD-MM-YYYY"
              isDisabled={true}
            />
          </div>

          <div className="col-lg-4 col-md-4 col-sm-6">
            <div className="form-group"></div>
            <label>Additional Loan Amount</label>
            <InputForm
              placeholder={""}
              value={AdditionalLoanAmount}
              // onChange={(event: any) =>
              //   handleTextEvent(event, "accountNumber")
              // }
              isDisabled={true}
            />
          </div>
          <div className="col-lg-4 col-md-4 col-sm-6">
            <div className="form-group"></div>
            <label>Additional Balance Loan Amount</label>
            <InputForm
              placeholder={"Additional Outstanding Amount"}
              value={OutstandingAmountAL}
              // onChange={(event: any) =>
              //   handleTextEvent(event, "accountNumber")
              // }
              isDisabled={true}
            />
          </div>
        </div>
      )}
    </>
  );
};

export default StlmtLoanDetails;
